export const BulkCapacityMatchJobStatus = {
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
	NEW: 'NEW',
	NOTIFICATION_PENDING: 'NOTIFICATION_PENDING',
	PROCESSED: 'PROCESSED',
	PROCESSING: 'PROCESSING',
	SCHEDULED: 'SCHEDULED',
	STAGED: 'STAGED',
};
